<template>
  <div id="nav" class="navbar py-3 px-3">
    <!-- Top Navbar exactly as original to avoid breaking layout -->
    <b-row class="w-100 mx-0 align-items-center">
      <b-col cols="2" md="3" class="px-0 text-left">
        <b-avatar
            v-show="visiblebutton"
            @click="voltar()"
            :style="ESTILOS.avatar"
            class="shadow-sm"
            button
            icon="arrow-left-circle-fill">
        </b-avatar>
      </b-col>

      <b-col cols="8" md="6" class="px-1 text-center">
        <router-link :to="$route.path" style="text-decoration: none;">
          <h5 :style="ESTILOS.titulo" class="m-0 font-weight-bold" style="letter-spacing: -0.5px;">
            {{ $route.name }}
          </h5>
        </router-link>
      </b-col>

      <b-col cols="2" md="3" class="px-0 text-right">
        <b-avatar
            v-b-toggle.sidebar-right
            :style="ESTILOS.avatar"
            class="shadow-sm"
            button
            icon="list">
        </b-avatar>
      </b-col>
    </b-row>

    <!-- Sidebar Wrapper exactly as original -->
    <div>
      <b-sidebar
          id="sidebar-right"
          :style="ESTILOS.sidebar"
          :width="larguraSidebar"
          backdrop
          shadow="lg"
          no-header>
        
        <!-- Background Wrapper -->
        <div class="bg-sidebar d-flex flex-column h-100">
          
          <!-- Logo Section -->
          <div class="p-3 text-center mt-2">
            <b-img src="/img/icons/helpdek.png" fluid style="max-width: 70%;"></b-img>
          </div>

          <!-- Divider -->
          <div class="mb-1" style="height: 1px; background: rgba(255,255,255,0.1);"></div>

          <!-- Navigation Menu -->
          <div class="flex-grow-1 overflow-auto scroll-modern">
            <b-nav vertical class="modern-nav">
              
              <b-nav-item to="/dashboard" @click="ocultarSidebar" class="modern-item" v-if="ehAdminOuSupervisor">
                <div class="item-content">
                  <b-icon icon="bar-chart-fill" class="mr-3 icon-size"></b-icon>
                  <span>Dashboard</span>
                </div>
              </b-nav-item>

              <b-nav-item to="/bloco" @click="ocultarSidebar" class="modern-item">
                <div class="item-content">
                  <b-icon icon="house-door" class="mr-3 icon-size"></b-icon>
                  <span>Início</span>
                </div>
              </b-nav-item>

              <b-nav-item to="/chamados-abertos" @click="ocultarSidebar" class="modern-item">
                <div class="item-content">
                  <b-icon icon="card-checklist" class="mr-3 icon-size"></b-icon>
                  <span>Chamados</span>
                </div>
              </b-nav-item>

              <!-- Cadastros -->
              <template v-if="perfilService.ehAdministrador">
                <div class="my-2" style="height: 1px; background: rgba(255, 255, 255, 0.15);"></div>
                <div class="menu-label mt-2 mb-1">Administração</div>
                
                <b-nav-item
                    v-for="item in itensCadastro"
                    :key="item.rota"
                    :to="item.rota"
                    @click="ocultarSidebar"
                    class="modern-item">
                  <div class="item-content">
                    <b-icon :icon="item.icone" class="mr-3 icon-size"></b-icon>
                    <span>{{ item.titulo }}</span>
                  </div>
                </b-nav-item>
                
                <b-nav-item
                    to="/gerenciar/local"
                    @click="ocultarSidebar"
                    class="modern-item"
                    v-if="ehAdministrador">
                  <div class="item-content">
                    <b-icon icon="building" class="mr-3 icon-size"></b-icon>
                    <span>Local</span>
                  </div>
                </b-nav-item>
              </template>

              <!-- Inventário Collapsible -->
              <div v-if="ehAdminSupervisorOuOperador">
                <div class="my-2" style="height: 1px; background: rgba(255, 255, 255, 0.15);"></div>
                <div v-b-toggle.collapse-inventario class="menu-label mt-2 mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                  <span>Inventário</span>
                  <b-icon icon="chevron-down" font-scale="0.9"></b-icon>
                </div>
                <b-collapse id="collapse-inventario">
                  <div class="collapse-wrapper">
                    <b-nav-item
                        v-for="item in inventarioFiltrado"
                        :key="item.rota"
                        :to="item.rota"
                        @click="ocultarSidebar"
                        class="modern-item-sub">
                      <div class="item-content-sub">
                        <b-icon :icon="item.icone" class="mr-2 icon-size-sub"></b-icon>
                        <span>{{ item.titulo }}</span>
                      </div>
                    </b-nav-item>
                  </div>
                </b-collapse>
              </div>

              <!-- Checklist Collapsible -->
              <div v-if="ehAdminSupervisorOuOperador">
                <div class="my-2" style="height: 1px; background: rgba(255, 255, 255, 0.15);"></div>
                <div v-b-toggle.collapse-checklist-menu class="menu-label mt-2 mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                  <span>Checklist</span>
                  <b-icon icon="chevron-down" font-scale="0.9"></b-icon>
                </div>
                <b-collapse id="collapse-checklist-menu">
                  <div class="collapse-wrapper">
                    <b-nav-item
                        v-for="item in checklistMenuFiltrado"
                        :key="item.rota"
                        :to="item.rota"
                        @click="ocultarSidebar"
                        class="modern-item-sub">
                      <div class="item-content-sub">
                        <b-icon :icon="item.icone" class="mr-2 icon-size-sub"></b-icon>
                        <span>{{ item.titulo }}</span>
                      </div>
                    </b-nav-item>
                  </div>
                </b-collapse>
              </div>

              <!-- Ocorrências e Relatórios -->
              <div class="my-2" style="height: 1px; background: rgba(255, 255, 255, 0.15);"></div>
              
              <b-nav-item
                  to="/ocorrencia/gerenciar"
                  @click="ocultarSidebar"
                  class="modern-item mt-2"
                  v-if="ehAdministrador">
                <div class="item-content">
                  <b-icon icon="list-task" class="mr-3 icon-size"></b-icon>
                  <span>Ocorrências</span>
                </div>
              </b-nav-item>
              
              <b-nav-item
                  to="/relatorios/gerar"
                  @click="ocultarSidebar"
                  class="modern-item"
                  v-if="ehAdministrador">
                <div class="item-content">
                  <b-icon icon="pie-chart-fill" class="mr-3 icon-size"></b-icon>
                  <span>Gerar Relatórios</span>
                </div>
              </b-nav-item>

            </b-nav>
          </div>

          <!-- Alternador de Tema -->
          <div class="px-3 pb-3 mt-auto text-center">
            <b-button @click="toggleTheme" variant="outline-light" class="w-100 d-flex align-items-center justify-content-center" style="border-radius: 12px; padding: 10px; border-color: rgba(255,255,255,0.3);">
              <b-icon :icon="isDarkMode ? 'sun' : 'moon'" class="mr-2 font-weight-bold" font-scale="1.2"></b-icon>
              <strong style="font-size: 0.9rem;">{{ isDarkMode ? 'Modo Claro' : 'Modo Escuro' }}</strong>
            </b-button>
          </div>

          <!-- Botão Sair Moderno -->
          <div class="p-3" style="background: rgba(0,0,0,0.15);">
             <b-nav-item to="/" @click="ocultarSidebar" class="modern-item logout-btn">
                <div class="item-content text-danger justify-content-center" style="border-radius: 12px; padding: 10px; margin-right: 0;">
                  <b-icon icon="power" class="mr-2 font-weight-bold" font-scale="1.3"></b-icon>
                  <strong style="font-size: 1rem;">Sair do Sistema</strong>
                </div>
             </b-nav-item>
          </div>

        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import {PerfilService} from '@/services/PerfilService';

const CORES = {
  PRIMARIA: '#303f9f',
  BRANCA: '#ffffff'
};

const ESTILOS = {
  coluna: 'text-align: left; padding: 0px',
  colunaCenter: 'text-align: center; padding: 0px',
  colunaRight: 'text-align: right; padding: 0px',
  avatar: `background-color: ${CORES.PRIMARIA}`,
  titulo: `color: ${CORES.PRIMARIA}`,
  sidebar: 'text-align: left',
  navItem: `color: ${CORES.BRANCA}`
};

const ITENS_CADASTRO = [
  {rota: '/cadastro/bloco', icone: 'bricks', titulo: 'Bloco'},
  {rota: '/cadastro/andar', icone: 'distribute-vertical', titulo: 'Andar'},
  {rota: '/cadastro/corredor', icone: 'signpost-split', titulo: 'Corredor'},
  {rota: '/cadastro/sala', icone: 'easel-fill', titulo: 'Sala'},
  {rota: '/cadastro/setor', icone: 'wrench', titulo: 'Setor'},
  {rota: '/cadastro/problema', icone: 'exclamation-triangle-fill', titulo: 'Problema'},
  {rota: '/cadastro/parametro', icone: 'gear-fill', titulo: 'Parâmetro'},
  {rota: '/cadastro/usuario', icone: 'people-fill', titulo: 'Usuário'},
  {rota: '/checklist/itens', icone: 'list', titulo: 'Itens', ViewAdmin: true},
];

const INVENTARIO = [
  {rota: '/inventario/novo', icone: 'plus-square', titulo: 'Novo'},
  {rota: '/inventario/lista', icone: 'card-checklist', titulo: 'Listar'},
  {rota: '/solicitacao/inventario/nova', icone: 'file-earmark-plus', titulo: 'Nova Solicitação', ViewAdmin: true},
  {rota: '/solicitacao/inventario/lista', icone: 'file-earmark-check', titulo: 'Listar Solicitações', ViewAdmin: true}
];

const CHECKLIST = [
  {rota: '/checklist/novo', icone: 'clipboard-plus', titulo: 'Novo'},
  {rota: '/checklist/lista', icone: 'clipboard-check', titulo: 'Listar'},
  {rota: '/solicitacao/checklist/nova', icone: 'file-earmark-plus', titulo: 'Nova Solicitação', ViewAdmin: true},
  {rota: '/solicitacao/checklist/lista', icone: 'file-earmark-check', titulo: 'Listar Solicitações', ViewAdmin: true}
];

export default {
  name: 'BarraNavegacao',
  created() {
    this.inicializarComponente();
  },
  data() {
    return {
      ESTILOS,
      itensCadastro: ITENS_CADASTRO,
      inventario: INVENTARIO,
      checklistMenu: CHECKLIST,
      perfilService: null,
      ehAdminOuSupervisor: false,
      ehAdminSupervisorOuOperador: false,
      ehAdministrador: false,
      larguraTela: window.innerWidth,
      isDarkMode: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.atualizarLarguraTela);
    this.isDarkMode = localStorage.getItem('theme') === 'dark';
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.atualizarLarguraTela);
  },
  props: {
    visiblebar: {
      type: Boolean,
      default: false
    },
    visiblebutton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inventarioFiltrado() {
      return this.inventario.filter(item => {
        if (item.ViewAdmin) {
          return this.ehAdminOuSupervisor;
        }
        return true;
      });
    },
    checklistMenuFiltrado() {
      return this.checklistMenu.filter(item => {
        if (item.ViewAdmin) {
          return this.ehAdminOuSupervisor;
        }
        return true;
      });
    },
    larguraSidebar() {
      if (this.larguraTela <= 300) {
        return '75%';
      } else {
        return '285px';
      }
    }
  },
  methods: {
    inicializarComponente() {
      this.perfilService = new PerfilService();
      this.ehAdminOuSupervisor = this.perfilService.ehAdminOuSupervisor;
      this.ehAdminSupervisorOuOperador = this.perfilService.ehAdminSupervisorOuOperador;
      this.ehAdministrador = this.perfilService.ehAdministrador;
    },
    voltar() {
      this.$router.go(-1);
    },
    ocultarSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right');
    },
    atualizarLarguraTela() {
      this.larguraTela = window.innerWidth;
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      if (this.isDarkMode) {
        document.body.classList.add('dark-theme');
        localStorage.setItem('theme', 'dark');
      } else {
        document.body.classList.remove('dark-theme');
        localStorage.setItem('theme', 'light');
      }
    }
  }
};
</script>

<style scoped>
::v-deep .b-sidebar-backdrop {
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  background-color: rgba(0, 0, 0, 0.45) !important;
}

.bg-sidebar {
  background-color: #303f9f !important;
  min-height: 100vh;
  color: #ffffff;
}

/* Scroll customizado para não ficar feio */
.scroll-modern::-webkit-scrollbar {
  width: 5px;
}
.scroll-modern::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.modern-nav /deep/ a.nav-link {
  padding: 0 !important;
  text-decoration: none;
}

.modern-item {
  margin-bottom: 2px;
}

.item-content {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  border-radius: 0 20px 20px 0;
  margin-right: 15px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-left: 3px solid transparent; 
}

.icon-size {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

/* Hover e Ativo */
.modern-item:hover .item-content {
  background-color: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  border-left: 3px solid #ffffff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.modern-item:hover .icon-size {
  transform: scale(1.15); 
}

.menu-label {
  color: rgba(255, 255, 255, 0.9); /* Cor bem mais clara e visível */
  font-size: 0.75rem; /* Um pouquinho maior para melhorar a leitura */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding: 4px 20px;
}

.cursor-pointer {
  cursor: pointer;
  transition: color 0.2s;
}
.cursor-pointer:hover {
  color: #ffffff;
}

.collapse-wrapper {
  margin-top: 2px;
  margin-bottom: 4px;
}

.modern-item-sub {
  margin-bottom: 0px;
}

.item-content-sub {
  display: flex;
  align-items: center;
  padding: 6px 20px 6px 45px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.85rem;
  transition: all 0.2s ease;
}

.icon-size-sub {
  font-size: 1.05rem;
}

.modern-item-sub:hover .item-content-sub {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.08);
}

/* =========== BOTÃO SAIR =========== */
.logout-btn .item-content {
  background-color: rgba(220, 53, 69, 0.1);
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 0 10px;
}
.logout-btn:hover .item-content {
  background-color: #dc3545;
  color: #ffffff !important;
  border-left: 3px solid transparent;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
}
</style>
